import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BreezeRegenerateIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BreezeRegenerate",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M30.85 7.89c-3.66 0-6.72-3.05-6.72-6.71 0-.26-.21-.46-.47-.46s-.46.21-.46.47c0 3.66-3.06 6.71-6.72 6.71a.47.47 0 1 0 0 .94c3.66 0 6.72 3.05 6.72 6.71 0 .26.21.47.46.47s.47-.21.47-.47c0-3.66 3.06-6.71 6.72-6.71.26 0 .47-.21.47-.46a.47.47 0 0 0-.47-.47ZM23.92 20.03c-.67-.14-1.34.3-1.47.98-.87 4.25-4.51 7.44-8.84 7.75-2.6.19-5.1-.65-7.07-2.35a9.66 9.66 0 0 1-3.33-6.66 9.67 9.67 0 0 1 6.86-10l-1.11 1.38c-.44.53-.35 1.32.18 1.76.24.18.51.27.79.27.36 0 .73-.15.97-.46l2.83-3.5s.13-.17.16-.23c.3-.52.17-1.19-.3-1.57l-3.55-3.05c-.52-.45-1.31-.39-1.76.14-.45.52-.39 1.31.13 1.76L9.6 7.28C4 8.83.29 14.08.71 19.93A12.17 12.17 0 0 0 4.9 28.3c2.25 1.94 5.05 2.99 7.99 2.99.3 0 .6-.02.9-.04 5.44-.39 10.01-4.39 11.11-9.74.13-.68-.3-1.34-.98-1.48"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M11.95 14c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l4.29-4.29-4.29-4.29a.996.996 0 1 1 1.41-1.41l5 5c.39.39.39 1.02 0 1.41l-5 5c-.2.2-.45.29-.71.29Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.55 30.11C7.18 30.11 2 24.93 2 18.56S7.18 7 13.55 7h3.39c.55 0 1 .45 1 1s-.45 1-1 1h-3.39C8.28 9 4 13.29 4 18.55s4.29 9.55 9.55 9.55c4.92 0 9.01-3.69 9.5-8.58a1 1 0 1 1 1.99.21c-.6 5.91-5.54 10.37-11.49 10.37Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M19.03 11c2.76 0 5 2.24 5 5 0-2.76 2.24-5 5-5-2.76 0-5-2.24-5-5 0 2.76-2.24 5-5 5"
      }), /*#__PURE__*/_jsx("path", {
        d: "M24.03 17c-.55 0-1-.45-1-1 0-2.21-1.79-4-4-4-.55 0-1-.45-1-1s.45-1 1-1c2.21 0 4-1.79 4-4 0-.55.45-1 1-1s1 .45 1 1c0 2.21 1.79 4 4 4 .55 0 1 .45 1 1s-.45 1-1 1c-2.21 0-4 1.79-4 4 0 .55-.45 1-1 1m-1.69-6c.67.44 1.24 1.02 1.69 1.69.44-.67 1.02-1.24 1.69-1.69a6 6 0 0 1-1.69-1.69c-.44.67-1.02 1.24-1.69 1.69"
      })]
    })
  }));
};